export enum statusEnum {
  Inactive,
  Active,
  'Error',
}

export namespace statusEnum {
  export function values() {
    return Object.keys(statusEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
